import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
import { FetchResultType } from "../fetchTypes";
import { UserListType } from "../../common/types/UserTypes";

export const getAllUsers = createAsyncThunk(
  "/user",
  async ( params: any, { rejectWithValue }) => {
    try {
      const method = "/user";
      const { data, errorMessage, isSuccess } = await commonNetwork.get(method, params);
      if (isSuccess) {
        data.sort((a: any, b: any) => b.userId - a.userId);
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (error: any) {
      return rejectWithValue(error.data.message);
    }
  }
)

export interface userListStateType  extends FetchResultType{
    userList:UserListType
}
export const userListSlice = createSlice({
  name: "userList",
  initialState: {
    userList: [],
    isfirmAvailable: true,
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
    isFetchComplete: false
  },
  reducers: {
    clearState: (state) => {
      state.userList = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.isFetchComplete = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllUsers.fulfilled, (state, { payload }) => {
      state.userList = payload;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false; 
      state.isFetchComplete = true;
      return state;
    });
    builder.addCase(getAllUsers.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true; 
      // state.errorMessage = payload.message;
    });
    builder.addCase(getAllUsers.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = userListSlice.actions;

export const userSelector = (state:any) => state.userList;

export const userListReducer = userListSlice.reducer;
